var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternalLinkIcon = function SvgExternalLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      fill: "none"
    },
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.304 3C3.584 3 3 3.584 3 4.304V15.75a.75.75 0 0 0 1.5 0V4.5h15.115v15.115H8.365a.75.75 0 0 0 0 1.5h11.447c.72 0 1.303-.583 1.303-1.303V4.304c0-.72-.583-1.304-1.303-1.304zm3.311 9.058a.75.75 0 0 0 .75.75h1.882l-6.566 6.566a.75.75 0 0 0 1.06 1.06l6.567-6.566v1.882a.75.75 0 0 0 1.5 0v-3.692a.75.75 0 0 0-.218-.529l-.002-.002-.002-.001a.75.75 0 0 0-.528-.218H8.365a.75.75 0 0 0-.75.75"
  })));
};
export default SvgExternalLinkIcon;